/*
 * Copyright (c) 2018 teamapps.org (see code comments for author's name)
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * THIS IS GENERATED CODE!
 * PLEASE DO NOT MODIFY - ALL YOUR WORK WOULD BE LOST!
 *
 * @author	Yann Massard, yamass@gmail.com
 * @author	Matthias Bernstein, matthias.bernstein@data-centrics.com
 */
export const typescriptDeclarationFixConstant = 1;

import {UiSubEvent} from "./UiSubEvent";
import {TeamAppsEventListener} from "../modules/util/TeamAppsEvent";

export class SubEventRegistrator {
	public static registerForUiFieldSubEvents(eventSource: any, eventHandler: TeamAppsEventListener<UiSubEvent>) {
			 eventSource.onSpecialKeyPressed && eventSource.onSpecialKeyPressed.addListener(eventHandler);
			 eventSource.onTextInput && eventSource.onTextInput.addListener(eventHandler);
			 eventSource.onImageUploadFailed && eventSource.onImageUploadFailed.addListener(eventHandler);
			 eventSource.onImageUploadSuccessful && eventSource.onImageUploadSuccessful.addListener(eventHandler);
			 eventSource.onImageUploadStarted && eventSource.onImageUploadStarted.addListener(eventHandler);
			 eventSource.onImageUploadTooLarge && eventSource.onImageUploadTooLarge.addListener(eventHandler);
			 eventSource.onClicked && eventSource.onClicked.addListener(eventHandler);
			 eventSource.onFileRemoveButtonClicked && eventSource.onFileRemoveButtonClicked.addListener(eventHandler);
			 eventSource.onFileClicked && eventSource.onFileClicked.addListener(eventHandler);
			 eventSource.onFileUploadError && eventSource.onFileUploadError.addListener(eventHandler);
			 eventSource.onFileUploaded && eventSource.onFileUploaded.addListener(eventHandler);
			 eventSource.onLazyChildDataRequested && eventSource.onLazyChildDataRequested.addListener(eventHandler);
	}
}